export const REQUEST_BLACK_LIST = 'REQUEST_BLACK_LIST';
export const SUCCESS_BLACK_LIST = 'SUCCESS_BLACK_LIST';
export const FAILURE_BLACK_LIST = 'FAILURE_BLACK_LIST';
export const REQUEST_BLACK_LIST_ITEM = 'REQUEST_BLACK_LIST_ITEM';
export const SUCCESS_BLACK_LIST_ITEM = 'SUCCESS_BLACK_LIST_ITEM';
export const FAILURE_BLACK_LIST_ITEM = 'FAILURE_BLACK_LIST_ITEM';
export const GET_BLACK_LIST_TOTAL = 'GET_BLACK_LIST_TOTAL';
export const IMPORT_BLACK_LIST = 'IMPORT_BLACK_LIST';